import styles from './index.module.css'
import { Pagination } from '@appkit4/react-components/pagination'
import classnames from 'classnames'

export const View = ({ className, ...props }) => {
    return <Pagination className={classnames(styles.default, className)} {...props} />
}
